import { render, staticRenderFns } from "./polZhuanUsdt.vue?vue&type=template&id=b81560e2&scoped=true"
import script from "./polZhuanUsdt.vue?vue&type=script&lang=js"
export * from "./polZhuanUsdt.vue?vue&type=script&lang=js"
import style0 from "./polZhuanUsdt.vue?vue&type=style&index=0&id=b81560e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81560e2",
  null
  
)

export default component.exports